export default {
  formSubmitHost: 'https://contact.apps-api.instantpage.secureserver.net',
  generateUrlHost: 'https://url-generator.apps.secureserver.net',
  contactsHost: 'https://contacts.godaddy.com',
  conversationsWebHost: 'https://conversations.godaddy.com'
};
